module.exports = __webpack_public_path__ + "static/media/plus_white.a803b264.svg";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/plus_white.svg
// module id = 28
// module chunks = 0